import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { Dialog, Box, Paper, Typography } from '@material-ui/core';
import { loginUser, updateSession } from '../../reducers';
import {
  isEmailExistRequest,
  signUpRequest,
  recoverPassword
} from '../../services/api.service';
import * as FbService from '../../services/fb.service';
// import Connect from './Connect';
// import ChoiceSignUp from './ChoiceSignUp';
// import SignUpTutor from './SignUpTutor';
// import SignUpTutee from './SignUpTutee';
import ManageErrors from './ManageErrors';
import { LocalStorage } from '../../services/localstorage.service';
import './sign-up.scss';
// import Loader from '../../components/loader';
import Page from '../../components/page';
import { ROUTES } from '../';
// import ForgotPassModal from '../../components/header/components/forgot-pass-modal';
// import CustomButton from '../forgot-password/CustomButton';
import ContinueForm from './Continue';
import Login from './Login';
import RegisterChoice from './RegisterChoice';
import RegisterTuteeForm from './RegisterTutee';
import RegisterTutorForm from './RegisterTutor';
import { useMediaQuery } from 'react-responsive';
import ForgotPasswordForm from './ForgotPassword';

import { useHistory } from 'react-router-dom';

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function ResponsiveModal({ children, ...props }) {
  const isMobile = useMediaQuery({ maxWidth: 670 });
  return (
    <Dialog maxWidth="xs" fullScreen={isMobile} {...props}>
      {children}
    </Dialog>
  );
}

class SignUp extends Component {
  constructor(props) {
    super(props);
    let route =
      this.props.location.hash.replace('#', '') || 'initIdentification';
    // if (props.info) {
    //   if (props.info.onlyTutor) route = 'signupTutor';
    //   else if (props.info.onlyTutee) route = 'signupTutee';
    // }

    this.forgotPassModalRef = createRef();
    this.formRef = createRef();
    this.emailFieldRef = createRef();
    this.state = {
      forgotPassModalVisible: false,

      formModal: {
        // title: 'Connexion ou Inscription',
        typeStudent: 'tutee',

        loading: false,
        facebook_id: null,
        email: null,
        firstName: null,
        phoneNumber: null,
        password: null,
        submitted: null,
        isCheckingEmail: false
      },

      editableEmail: true,
      facebookReady: true, // TODO
      fbShowBtn: true,
      hidePassField: false,
      fbError: null,

      errors: {
        email_invalid: false,
        already_signed: false,
        first_name_empty: false,
        password_empty: false,
        school_invalid: false,
        signup_invalid: false,
        school_email: false
      },

      routing: {
        initIdentification: route === 'initIdentification',
        connexion: false,
        choiceSignUp: false,
        signupTutor: route === 'signupTutor',
        signupTutee: route === 'signupTutee',
        forgotPassword: route === 'forgotPassword'
      }
    };
  }

  componentDidMount() {
    const { route } = this.props;

    this.init();

    this.updateSession();
    // this.initFacebook();

    // if (route) {
    //   this.setRoute(route);
    // }
  }

  componentDidUpdate(prevProps) {
    if (this.props.email !== prevProps.email) {
      this.changeFormModal({ email: this.props.email });
    }
  }

  close = () => this.props.close();

  updateSession = () => {
    this.props.updateSession().then(async session => {
      if (session.is_connected) {
        if (session.user_tutor) {
          // Tutor
          const url = await LocalStorage.getItem('url_offre');
          if (!!url && session.is_onboarding_finished) {
            this.props.goTo(url);
            LocalStorage.removeItem('url_offre');
          } else {
            this.props.goTo(
              session.is_onboarding_finished
                ? session.matched
                  ? ROUTES.TUTOR_REPORTS_COURSE
                  : ROUTES.TUTOR_DASHBOARD
                : ROUTES.TUTOR_ONBOARDING
            );
          }

          /* this.props.goTo(session.is_onboarding_finished ? ROUTES.TUTOR_DASHBOARD : ROUTES.TUTOR_ONBOARDING); */
        } else {
          // console.log('session data', session);
          const show_ai =
            session.statut_ai == 'A activer' || session.statut_ai == null;
          const see_ai = LocalStorage.getItem('see_ai_page') || 'on';
          const see_ai_ = see_ai === 'on' && show_ai && session.eligible_sai && session.wants_visio=='f';
          this.props.goTo(
            session.customer_type === 'client'
              ? see_ai_ ? ROUTES.TUTEE_SAI : ROUTES.TUTEE_COURSE_MONITORING_PLANNING
              : ROUTES.TUTEE_START
          );
        }
      }
    });
  };

  init = () => {
    // const { info } = this.props;
    let route =
      this.props.location.hash.replace('#', '') || 'initIdentification';

    // if (info) {
    //   if (info.onlyTutor) route = 'signupTutor';
    //   else if (info.onlyTutee) route = 'signupTutee';
    // }

    this.setRoute(route);
  };

  initFacebook = () => {
    this.setState({ fbShowBtn: true, hidePassField: false });

    // Set Handlers
    FbService.setLoginHandler(params => {
      LocalStorage.setItem('auth_token', params.response.auth_token);
      this.updateSession();
    });

    FbService.setRegistrationHandler(params => {
      this.setRoute('choiceSignUp');
      this.setState({
        fbShowBtn: false,
        hidePassField: true,
        editableEmail: false
      });
      this.changeFormModal({
        email: params.fb_user_fields_data.email,
        facebook_id: params.fb_user_fields_data.id,
        firstName: params.fb_user_fields_data.first_name
      });
    });

    FbService.setErrorHandler(params => this.setState({ fbError: params.msg }));
  };

  changeState = (propName, data = {}, force = false) =>
    this.setState({
      [propName]: force
        ? data || {}
        : Object.assign({}, this.state[propName] || {}, data || {})
    });

  changeErrors = (data, force) => this.changeState('errors', data, force);
  changeRouting = (data, force) => this.changeState('routing', data, force);
  changeFormModal = (data, force = false) =>
    this.changeState('formModal', data, force);
  formLoading = (loading = false) => this.changeFormModal({ loading });
  clearErrors = () =>
    this.changeErrors(
      {
        email_invalid: false,
        already_signed: false,
        first_name_empty: false,
        password_empty: false,
        school_invalid: false,
        signup_invalid: false,
        school_email: false
      },
      true
    );

  connect = values => {
    // const isFormValid = this.formRef.current.checkValidity();
    this.formLoading(true);

    return this.props
      .loginUser(values)
      .then(() => {
        this.updateSession();
      })
      .catch(error => {
        this.formLoading(false);
        this.changeErrors({ login: true, msg: error.message });
      });
  };

  signIn = (values, type) => {
    const { routing, formModal, errors } = this.state;
    // const isFormValid = this.formRef.current.checkValidity();

    // Si l'on vient de la directive onEnter ou qu'il s'inscrit
    // if (routing.connexion || !isFormValid || formModal.loading) return;

    // formModal.typeStudent = type;
    // this.changeFormModal(formModal);

    this.formLoading(true);

    return signUpRequest({
      typeStudent: 'tutor',
      ...values
    });
  };

  sendEmail = ({ email }) => {
    return recoverPassword(email);
  };

  openForgotPassModal = () =>
    this.setState({
      forgotPassModalVisible: true
    });

  closeForgotPassModal = () => this.setState({ forgotPassModalVisible: false });

  isEmailExistCheck = () => {
    const { formModal, routing, errors } = this.state;
    const { email } = formModal || {};
    const isValid = EMAIL_REGEX.test(email);
    let isEmailInvalid = true;
    this.setState({ formModal: { ...formModal, isCheckingEmail: true } });

    if (isValid) {
      isEmailExistRequest({ email })
        .then(() => {
          isEmailInvalid = false;
          if (!routing.connexion) this.setRoute('connexion');
        })
        .catch(() => {
          if (!routing.signupTutor && !routing.signupTutee) {
            isEmailInvalid = false;
            this.setRoute('choiceSignUp');
          } else {
            isEmailInvalid = true;
          }
        })
        .finally(() => {
          this.setState({
            formModal: { ...formModal, isCheckingEmail: false },
            errors: { ...errors, email_invalid: isEmailInvalid }
          });
        });
    } else {
      this.setState({
        formModal: { ...formModal, isCheckingEmail: false },
        errors: { ...errors, email_invalid: isEmailInvalid }
      });
    }
  };

  setRoute = (route, option) => {
    const { info = {} } = this.props;
    const routing = Object.assign({}, this.state.routing);
    const changes = {
      // title: null,
      email: null
    };

    Object.keys(routing).forEach(key => (routing[key] = route === key));

    this.props.history.push(`#${route}`);

    // On gère les cas particuliers
    switch (route) {
      case 'connexion':
        routing.initIdentification = false;
        // changes.title = 'Connexion';
        break;

      case 'choiceSignUp':
        // changes.title = 'Créer un compte';
        if (info && 'onlyStudent' in info)
          return this.setRoute(
            info.onlyStudent ? 'signupTutee' : 'signupTutor'
          );
      // break;

      // case 'signupTutee':
      // changes.title = 'Terminer mon inscription'; // 'Inscription élève';
      //   break;

      // case 'signupTutor':
      // changes.title = 'Conditions pour donner des cours chez Clevermate';
      //   break;
      // case 'forgotPassword':
      // changes.title = 'Mot de passe oublié ?';
    }

    if (option === 'reset') changes.email = '';

    // À chaque fois qu'on change de route on init les erreurs et submitted
    this.clearErrors();
    this.changeFormModal({
      submitted: false,
      // ...(changes.title !== null ? { title: changes.title } : {}),
      ...(changes.email !== null ? { email: changes.email } : {})
    });

    setTimeout(() => this.changeRouting(routing));
  };

  render() {
    const { formModal, errors, info, routing } = this.state;
    const Wrap = ResponsiveModal;
    return (
      <Page id="signup" title="Sign Up">
        <div className="main-container">
          <Wrap open={true}>
            <Box
              style={{ padding: 24, margin: '0 auto', position: 'relative' }}
            >
              <a href="/">
                <div className="signup-logo">
                  <img
                    src="/img/clevermate-signature.png"
                    alt="clevermate signature"
                  />
                </div>
              </a>

              <div style={{ marginBottom: 8 }}>
                <ManageErrors errors={errors} info={info} />
              </div>
              {this.renderBody()}
            </Box>
          </Wrap>
        </div>
      </Page>
    );
  }

  onSuivantClick = e => {
    e.preventDefault();
    const { routing, formModal } = this.state;
    const { connexion } = routing || {};

    if (formModal.email && !connexion) {
      this.isEmailExistCheck();
    }
  };

  onSelectCareerClick = () => {
    this.setRoute('choiceSignUp');
  };

  renderBody() {
    const { info } = this.props;
    const {
      routing,
      formModal,
      hidePassField,
      editableEmail,
      forgotPassModalVisible,
      errors
    } = this.state;

    const { email, isCheckingEmail, phoneNumber, firstName } = formModal;

    const {
      initIdentification,
      connexion,
      choiceSignUp,
      signupTutor,
      signupTutee,
      forgotPassword
    } = routing || {};

    return (
      <form role="form" className="form" noValidate ref={this.formRef}>
        {initIdentification && (
          <div className="row-space-1">
            <ContinueForm
              onSuccess={({ email }) => {
                this.changeFormModal({ email });
                this.setRoute('connexion');
              }}
              onFailure={({ email }) => {
                this.changeFormModal({ email });
                this.setRoute('choiceSignUp');
              }}
            />
          </div>
        )}

        {connexion && (
          <div className="sgc-connexion">
            <Login
              email={email}
              onSubmit={this.connect}
              onChangePassword={() => this.setRoute('forgotPassword')}
              onSuccess={console.log}
              onFailure={console.log}
            />
          </div>
        )}

        {choiceSignUp && (
          <div className="sgc-choixInscription">
            {/* <ChoiceSignUp setRoute={this.setRoute.bind(this)} /> */}
            <RegisterChoice
              onTutorClick={() => this.setRoute('signupTutor')}
              onTuteeClick={async () => {
                const response = await fetch(
                  '/api_v3/prospect/is-email-exist?email=' +
                    encodeURIComponent(email)
                ).then(res => res.json());
                if (response.exist) {
                  const { phone, name } = response.prospect;
                  this.changeFormModal({
                    email,
                    phoneNumber: phone,
                    firstName: name
                  });
                }
                this.setRoute('signupTutee');
              }}
            />
          </div>
        )}

        {signupTutor && (
          <div className="sgc-inscriptionTutor inscription">
            <RegisterTutorForm
              email={email}
              onSubmit={values => this.signIn(values, 'tutor')}
              onSuccess={() => {
                this.props.showAlert(
                  'Bienvenue chez Clevermate !',
                  'Félicitations'
                );
                this.updateSession();
              }}
              onFailure={({ error = 'signup_invalid' }) => {
                this.changeErrors({
                  [error]: true
                });
              }}
            />
          </div>
        )}

        {signupTutee && (
          <div className="sgc-inscriptionTutee inscription">
            <RegisterTuteeForm
              email={email}
              phoneNumber={phoneNumber}
              name={firstName}
              onSubmit={signUpRequest}
              onSuccess={() => {
                //this.props.showAlert('Bienvenue chez Clevermate !', 'Félicitations');
                this.updateSession();
              }}
              onFailure={({ error = 'signup_invalid' }) => {
                this.updateSession();
                this.changeErrors({
                  [error]: true
                });
              }}
            />
          </div>
        )}

        {forgotPassword && (
          <ForgotPasswordForm
            email={email}
            onSubmit={this.sendEmail}
            onSuccess={({ email }) => {
              // this.props.showAlert(`Un lien pour réinitialiser votre mot de passe a été envoyé par e-mail à ${email}`);
            }}
            onFailure={() => {
              this.changeErrors({
                email_invalid: true
              });
            }}
          />
        )}
      </form>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ loginUser, updateSession }, dispatch),
  goTo: page => {
    dispatch(push(page));
  }
});

export default withRouter(connect(null, mapDispatchToProps)(SignUp));
